// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Confirmations: the shared dialog (main.css). */

.confirm-body {
  font-size: 1rem;
  line-height: 1.55;
  color: var(--brand-fg-read);
}

.confirm-body p {
  margin: 0 0 8px;
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmModal.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* Confirmations: the shared dialog (main.css). */\n\n.confirm-body {\n  font-size: 1rem;\n  line-height: 1.55;\n  color: var(--brand-fg-read);\n}\n\n.confirm-body p {\n  margin: 0 0 8px;\n  color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
